import { Suspense, lazy } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { RouteObject, useNavigate, useLocation } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

import { useEffect } from 'react';
const Loader = (Component) => (props) => {
  const location = typeof window !== 'undefined' ? window.location : { pathname: '' };
  let accesstoken = '';
  try {
    const tokenDataRaw = localStorage.getItem('act');
    const tokenData = tokenDataRaw ? JSON.parse(tokenDataRaw) : {};
    accesstoken = tokenData?.state?.accesstoken || '';
  } catch (e) {
    accesstoken = '';
  }

  // Use imperative navigation if possible
  if (accesstoken === '') {
    if (location.pathname !== '/login') {
      window.location.replace('/login');
      return null;
    } else {
      return (
        <Suspense fallback={<SuspenseLoader />}>
          <Component {...props} />
        </Suspense>
      );
    }
  } else {
    if (location.pathname === '/login') {
      window.location.replace('/');
      return null;
    } else {
      return (
        <Suspense fallback={<SuspenseLoader />}>
          <Component {...props} />
        </Suspense>
      );
    }
  }
};

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

/* ㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡㅡ */

// Sign
const SignIn = Loader(lazy(() => import('src/content/pages/Sign/In')));

// Pages
const Overview = Loader(lazy(() => import('src/content/overview')));

// ManageMent
const List = Loader(
  lazy(() => import('src/content/pages/Components/02_Lockup/00_List'))
);

const History = Loader(
  lazy(() => import('src/content/pages/Components/02_Lockup/01_History'))
);

const Management = Loader(
  lazy(() => import('src/content/pages/Components/02_Lockup/02_Management'))
);

const PurchaseInfo = Loader(
  lazy(() => import('src/content/pages/Components/02_Lockup/03_PurchaseInfo'))
);

const Member = Loader(
  lazy(() => import('src/content/pages/Components/01_Management/00_Member'))
);

const TempPwd = Loader(
  lazy(
    () =>
      import('src/content/pages/Components/01_Management/01_TemporaryPassword')
  )
);

const StakingList = Loader(
  lazy(() => import('src/content/pages/Components/03_Staking/00_List'))
);

const StakingListTypeU = Loader(
  lazy(() => import('src/content/pages/Components/03_Staking/01_List_Type_U'))
);

const P2PListBAGO = Loader(
  lazy(() => import('src/content/pages/Components/04_P2P/00_List_BAGO'))
);

const P2PListBATY = Loader(
  lazy(() => import('src/content/pages/Components/04_P2P/01_List_BATY'))
);

const Settings = Loader(
  lazy(
    () =>
      import('src/content/pages/Components/05_Settings/00_Numerical_Setting')
  )
);

const PopUp = Loader(
  lazy(() => import('src/content/pages/Components/05_Settings/01_Pop_Up'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="management" replace />
      },
      {
        path: 'login',
        element: <SignIn />
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="member" replace />
      },
      {
        path: 'member',
        element: <Member />
      },
      {
        path: 'temppwd',
        element: <TempPwd />
      }
    ]
  },
  {
    path: 'lockup',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: <List />
      },
      {
        path: 'history',
        element: <History />
      },
      {
        path: 'management',
        element: <Management />
      },
      {
        path: 'purchaseInfo',
        element: <PurchaseInfo />
      }
    ]
  },
  {
    path: 'staking',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />
      },
      {
        path: 'list/type/s',
        element: <StakingList />
      },
      {
        path: 'list/type/u',
        element: <StakingListTypeU />
      }
    ]
  },
  {
    path: 'p2p',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="list/BAGO" replace />
      },
      {
        path: 'list/BAGO',
        element: <P2PListBAGO />
      },
      {
        path: 'list/BATY',
        element: <P2PListBATY />
      }
    ]
  },
  {
    path: 'settings',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="numerical" replace />
      },
      {
        path: 'numerical',
        element: <Settings />
      },
      {
        path: 'popup',
        element: <PopUp />
      }
    ]
  }
];

export default routes;
